import styled from '@emotion/styled';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAnalytics } from '@/services/analytics';
import { AppRoutes } from '@/utils/types';

import back from './images/Back.svg';
import image from './images/Image.svg';

const Container = styled.div`
    height: 100%;
    width: 100%;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    padding-top: 8rem;
`;

const TopPart = styled.div`
    background: url(${image}) no-repeat center;
    width: 372px;
    height: 356px;
    margin-left: auto;
    z-index: 1;
`;
const BottomPart = styled.div`
    background-color: #f5faff;
    flex: 1;
    margin-top: -2rem;
    padding-top: 3rem;
`;
const Image = styled.img`
    padding-right: 1rem;
`;
const BackDiv = styled.div`
    background-color: #f5faff;
    flex: 1;
    padding-top: 3rem;
    text-align: center;
    font-size: 14px;
    text-align: center;
`;
const Title = styled.h1`
    font-weight: 700;
    font-size: 3.4rem;
    text-align: center;
    letter-spacing: -0.02em;
    color: #1b1c1e;
    line-height: 4.3rem;
`;

const Subtitle = styled.h2`
    font-weight: 500;
    font-size: rem;
    text-align: center;
    letter-spacing: -0.02em;

    color: #1b1c1e;
`;

export const UnsupportedPage = () => {
    const mixpanel = useAnalytics();
    useEffect(() => {
        mixpanel?.track('mobile-unsupported', { event: 'view' });
    }, []);
    const navigate = useNavigate();

    return (
        <Container>
            <TopPart />
            <BottomPart>
                <Title>Mobile experience coming soon... </Title>
                <Subtitle>
                    Please switch to desktop to create
                    <br />
                    your own video
                </Subtitle>
                <BackDiv onClick={() => navigate(AppRoutes.Home)}>
                    <Image src={back} />
                    back to Studio
                </BackDiv>
            </BottomPart>
            <div id="noticeable-widget" />
        </Container>
    );
};
